export const currency = {
  data () {
    return {
      currencies: ['usd', 'eur', 'gbp']
    }
  },
  methods: {
    getCurrencyByIndex(index) {
      return this.currencies[index]
    },
    getCurrencies() {
      return this.currencies
    }
  }
};